import {ISVG} from "../../common/Logo/Logo";

export interface IShape1Props extends Pick<ISVG, "fill"> {}

export const Shape6 = ({ fill }: IShape1Props) => {
    const _fill = fill ?? "white;";

    return (
        <svg
            width="417"
            height="78"
            viewBox="0 0 417 78"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M237.496 4.08993C283.108 -7.34627 336.145 5.68174 371.085 37.1534C405.006 67.7074 423.634 118.786 414.489 163.514C406.081 204.64 357.293 220.687 327.514 250.271C313.876 263.82 293.951 271.662 287.426 289.745C262.392 359.125 307.866 477.653 237.496 499.75C176.507 518.903 205.9 372.761 158.049 330.373C118.487 295.328 34.7157 340.998 7.28294 295.824C-17.9658 254.246 28.3797 202.168 55.7911 161.983C77.4207 130.275 116.105 118.996 145.077 93.8195C178.301 64.9497 194.803 14.7942 237.496 4.08993Z"
                fill={_fill}
            />
        </svg>
    );
};
